import { createBrowserRouter, Navigate, RouterProvider } from "react-router-dom";
import ScrollToTop from "../components/scrollToTop/scrollToTop";
import Login from "../views/dashboard/login/login";
import Admin from "../views/dashboard/admin/admin"
import Error404 from "../components/error404/error404";
import GuiaDeEstilos from "../views/guia-de-estilos/main";
import Assignment from "../views/dashboard/admin/export/assignment/assignment";
import AssignmentReservation from "../views/dashboard/admin/export/assignment/assignment-reservation";

const router = createBrowserRouter([
    {
        path: '/',
        element: <Login />,
        errorElement: <Error404 />
    },
    {
        path: '/guia-de-estilos',
        element: <GuiaDeEstilos />,
    },
    {
        path: '/dashboard',
        children: [
            {
                path: '',
                element: <Navigate to="/" replace/>
            },
            {
                path: 'login',
                element: <Login />
            },
            {
                path: 'admin',
                element: <Admin />
            }
        ]
    },

    {
        path: '/assignment',
        element: <Assignment />
    },
    {
        path: '/assignment-reservation',
        element: <AssignmentReservation/>
    }
]);

const MyRoutes = () => <RouterProvider router={router} ><ScrollToTop /></RouterProvider>;

export default MyRoutes;